module.exports = __webpack_public_path__ + "img/3899436.051d3957.jpg";